module.exports = __webpack_public_path__ + "static/media/1013026.5bc6d389.jpg";